import { sceneMarkdown } from "@hamlak/shared";
import { MarkdownBody } from "@hamlak/ui";

/** scene{body}: 장면. 채팅 `> …` 장면과 같은 렌더러(말풍선 없이 이탤릭). 본문은 줄 안 서식(굵게·취소선·지문)을 쓸 수 있다(AC0-254, docs/narrative-format.md). */
export function SceneBlock({ body }: { body: string }) {
  return (
    <div className="block block--scene" data-testid="block-scene">
      <MarkdownBody text={sceneMarkdown(body)} plain />
    </div>
  );
}
